import { gql } from '@apollo/client';

export const CONTRIBUTION = gql`
  fragment contribution on Contribution {
    id
    title
    description
    value
    proposalCount
    createdAt
    public
    company {
      ...basicInfo
    }
    skills {
      ...skill
    }
    accountType
    locked
    status
    userId
  }
`;
